"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const custom_select_1 = __importDefault(require("custom-select"));
var CustomSelect;
(function (CustomSelect) {
    if (typeof require !== 'undefined') {
        let customSelect = require("custom-select").default;
        require("../../../node_modules/custom-select/build/custom-select.css");
        require("../../../node_modules/custom-select/build/custom-select.min");
    }
    //const $customSelect = require("custom-select").default;
    const $selects = document.querySelectorAll('select');
    if ($selects.length) {
        $selects.forEach($select => {
            (0, custom_select_1.default)($select);
        });
    }
})(CustomSelect || (CustomSelect = {}));
